import React, { PureComponent } from 'react';

import BannerLayout from '../../layouts/banner';

import Image from '../../../../../containers/assets/instructor-customer-preferences.png'

class CustomerPreferences extends PureComponent {
  render() {

    const { activeRound, previousShownErrors } = this.props;

    return (
      <BannerLayout
        section="What to expect next"
        subSection="Customer preferences"
        alertText="Change in Customer Preferences"
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <p>Customer preferences are expected to change for some customers. Therefore, teams need to review Round <b>{activeRound + 1}</b> Customer Analysis to ensure their product still meets the minimum requirements for the customers that they are targeting.</p>
        )}
        visual={(
          <img src={Image} alt="Customer Preferences" />
        )
        }
        visualProps={{
          noBorder: true,
          noBackground: true
        }}
      />
    );
  }
}

export default CustomerPreferences;


// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/what-to-expect-next/customer-preferences.js